import { useState, useEffect, useLayoutEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';
import { FaChevronRight, FaChevronLeft, FaMobileAlt } from 'react-icons/fa';
import './FloatingPreview.scss';

const FloatingPreview = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [layoutLeft, setLayoutLeft] = useState(0);
  const [previewWidth, setPreviewWidth] = useState(399);
  const previewRef = useRef(null);

  const updateMetrics = () => {
    setWindowWidth(window.innerWidth);

    const commonLayout = document.querySelector('.common-layout');
    if (commonLayout) {
      setLayoutLeft(commonLayout.getBoundingClientRect().left);
    }

    if (previewRef.current?.offsetWidth) {
      setPreviewWidth(previewRef.current.offsetWidth);
    }
  };

  useEffect(() => {
    const handleResize = () => updateMetrics();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useLayoutEffect(() => {
    updateMetrics();
  });

  // Hide entirely on mobile/tablet devices
  if (windowWidth <= 1024) {
    return null;
  }

  // Fixed mode is only safe while the preview has enough space before the centered page content.
  const fixedLeftOffset = 30;
  const minGapFromContent = 32;
  const isLargeScreen = layoutLeft >= fixedLeftOffset + previewWidth + minGapFromContent;

  if (isLargeScreen) {
    return (
      <Box className="floating-preview-fixed" ref={previewRef}>
        {children}
      </Box>
    );
  }

  // Drawer mode for medium screens
  return (
    <>
      <Box className={`floating-preview-drawer ${isOpen ? 'open' : ''}`}>
        <Box className="drawer-handle" onClick={() => setIsOpen(!isOpen)}>
          <div className="handle-content">
            <FaMobileAlt />
            <span className="handle-text">תצוגה מקדימה</span>
            {isOpen ? <FaChevronRight /> : <FaChevronLeft />}
          </div>
        </Box>
        <Box className="drawer-content" ref={previewRef}>
          {children}
        </Box>
      </Box>
      
      {/* Backdrop for closing drawer when clicking outside */}
      {isOpen && <Box className="drawer-backdrop" onClick={() => setIsOpen(false)} />}
    </>
  );
};

FloatingPreview.propTypes = {
  children: PropTypes.node.isRequired
};

export default FloatingPreview;
